import { on_ready, is_elementor_edit } from 'js/utils';
import { hover_intent } from 'js/functions';
// import { add_to_cart_ajax_init } from 'src/woocommerce/js/add_to_cart';
// import { load_swiper_mobile } from 'modules/carousel/load_swiper_mobile';

import './internals.scss';

on_ready(()=>{

    if( is_elementor_edit() ) return;

    // add_to_cart_ajax_init();

    // load_swiper_mobile();
    
    // add delay on hover out - to avoid instant close/off
    hover_intent_init();
});

function hover_intent_init(){
    document.querySelectorAll('.hover_intent').forEach(el=>{
        const duration = el.dataset.duration || 300;
        hover_intent(el, duration);
    });
}